import { socialShareUrls } from '../utils/constants';

export const getSocialShareUrl = (type, actualPage) => {
  const sharingUrl = socialShareUrls.find((social) => social.id === type)?.url;
  if (sharingUrl) {
    return { externalLink: `${sharingUrl}${actualPage}` };
  }
  return null;
};
